module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAkBAAAAABU+skbAAAAAnRSTlMAAHaTzTgAAAAQSURBVHjaY2DgOcDAMLQIAAqCHLFOaS/xAAAAAElFTkSuQmCC"